module.exports = __webpack_public_path__ + "img/16@2x.83867b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/16@2x.png
// module id = JMCx
// module chunks = 0